import classNames from 'classnames'
import setupTouchPunch from './jquery-ui/touch-punch'
window.classNames = classNames

import $ from 'jquery'
import jqueryUjsInit from 'jquery-ujs'

window.$ = $
window.jQuery = $

// jquery-ujs checks window.jQuery to auto-initialize, but Rspack's module wrapper
// provides CommonJS-like exports/module, and window.jQuery isn't set yet at import
// time (same class of bug as the lodash global issue). So jquery-ujs exports its
// init function without calling it. Initialize explicitly.
if (typeof jqueryUjsInit === 'function') {
  jqueryUjsInit($)
}

// Setup Jquery-UI

import 'jquery-ui/core'
import 'jquery-ui/widget'
import 'jquery-ui/mouse'
import 'jquery-ui/sortable'
import 'jquery-ui/draggable'
import 'jquery-ui/droppable'

setupTouchPunch()

import setupI18n from './setup-i18n'
setupI18n()
